module.exports = __webpack_public_path__ + "assets/ic-medium.177925a9.svg";